define(['jquery', 'jquery.cycle2'], ($) => {
  const $box = $('.box-18380724');

  if ($box.length === 0) {
    return;
  }

  $box.find('> ul').addClass('cycle-slideshow')
    .data('cycle-fx', 'scrollHorz')
    .data('cycle-slides', '> li')
    .data('cycle-loader', true)
    .data('cycle-pause-on-hover', true)
    .cycle();
});
